export class ClientAuthorityModel {
    authority_id: number
    authority_desc: string

    constructor(
        authority_id: number,
        authority_desc: string
    ) {
        this.authority_id = authority_id
        this.authority_desc = authority_desc
    }
}